import type { SummaryActiveRun, SummarySelection } from './state/summaryUiSlice';

type Params = {
  streamingMarkdown: string;
  isSummaryStreaming: boolean;
  activeRun: SummaryActiveRun | null;
  selection: SummarySelection | null;
  artifactDataRevision: number | null;
};

export function shouldShowStreamingSummary(params: Params): boolean {
  const { streamingMarkdown, isSummaryStreaming, activeRun, selection, artifactDataRevision } =
    params;

  if (streamingMarkdown.trim() === '') return false;

  if (isSummaryStreaming) {
    return true;
  }

  if (!activeRun) return false;

  if (activeRun.status === 'completed' && (!activeRun.artifactId || !activeRun.revision)) {
    if (selection && selection.source !== 'persisted') {
      return false;
    }
    return true;
  }

  if (!selection) return false;

  const runArtifactId = activeRun.artifactId;
  const runRevision = activeRun.revision;
  if (!runArtifactId || typeof runRevision !== 'number' || runRevision <= 0) return false;

  if (runArtifactId !== selection.artifactId || runRevision !== selection.revision) return false;

  if (artifactDataRevision === selection.revision) return false;
  return true;
}

export function isAwaitingPersistedVersion(activeRun: SummaryActiveRun | null): boolean {
  if (!activeRun) return false;

  if (activeRun.status === 'started' || activeRun.status === 'streaming') {
    return true;
  }

  if (activeRun.status === 'completed' && (!activeRun.artifactId || !activeRun.revision)) {
    return true;
  }

  return false;
}
